module.exports = __webpack_public_path__ + "static/media/alarm-clock.0693f76b.svg";